import { formatCompact, formatMoney, formatNumber, formatPercent } from '../../utils/format';

/**
 * The insight metrics, in KPI order. money metrics take the currency; chart marks the ones the trend can plot
 * (CPC is left out: a day with few clicks swings it wildly), and color is its fixed colour on the chart.
 */
export const METRICS = [
  { id: 'spend', label: 'Spend', money: true, chart: true, color: '#2a78d6' },
  { id: 'impressions', label: 'Impressions', chart: true, color: '#eb6834' },
  { id: 'clicks', label: 'Clicks', chart: true, color: '#1baf7a' },
  { id: 'link_clicks', label: 'Link clicks', chart: true, color: '#eda100' },
  { id: 'ctr', label: 'CTR', percent: true, chart: true, color: '#e87ba4' },
  { id: 'cpc', label: 'CPC', money: true },
];

export function metricValue(values, metric) {
  const value = values?.[metric.id];
  return value == null ? null : Number(value);
}

export function formatMetric(value, metric, currency) {
  if (metric.money) return formatMoney(value, currency);
  if (metric.percent) return formatPercent(value);
  return formatNumber(value);
}

export function formatAxis(value, metric, currency) {
  if (metric.percent) return `${value}%`;
  return formatCompact(value, metric.money ? currency : null);
}

/**
 * Daily entries added up by unit (day, month or year), dated by their first day. CTR and CPC are worked out again from
 * the sums, as they do not add up.
 */
export function bucketDaily(daily, unit) {
  if (unit === 'day') return daily;
  const buckets = new Map();
  daily.forEach((day) => {
    const key = String(day.date).slice(0, unit === 'year' ? 4 : 7);
    const bucket = buckets.get(key) ?? { date: day.date, spend: 0, impressions: 0, clicks: 0, link_clicks: 0 };
    ['spend', 'impressions', 'clicks', 'link_clicks'].forEach((id) => {
      bucket[id] += Number(day[id]) || 0;
    });
    buckets.set(key, bucket);
  });
  return [...buckets.values()].map((bucket) => ({
    ...bucket,
    ctr: bucket.impressions ? Math.round((bucket.clicks * 10000) / bucket.impressions) / 100 : null,
    cpc: bucket.clicks ? bucket.spend / bucket.clicks : null,
  }));
}
